import React, { useEffect, useState } from "react";
import "@/app/pages/utilityPages/optoutContacts.scss";
import classNames from "classnames";
import AddOptoutContact from "@/app/pages/utilityPages/AddOptoutContact";
import {optoutcontactsDetails} from "@/app/pages/utilityPages/OptoutcontactsDetails/OptoutcontactsDetails"
import { getCompanyOptout, updateContactOptout } from "@/services/contactOptout";
import Loader from "@/components/loader";
import { ToastContainer, toast } from "react-toastify";
import { dnbComLog, isNotUndefinedOrNull, LogSeverity } from "@/shared/FunctionCore";

// Define the type for your objects
interface RowData {
  active: string;
  contactId: string;
  contactUrl: string;
  givenName: string;
  lastName: string;
  url: string;
  requestType: string;
  requestor: string;
  expirationDt: string;
  submitDt: string;
  updatedDt: string
}

const OptoutContacts = () => {
  const [enableExportOptions, setEnableExportOptions] = useState(false);
  // State to manage table rows data
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    getContactOptoutRecords();
  },[])

  const getContactOptoutRecords = async ()=>{
    setLoading(true);
    const contactOptoutRecords = await getCompanyOptout();
    setLoading(false);
    const {data} = contactOptoutRecords;
    const cleanRows = data.map(contact=>{
      return {
        active: contact.active,
        contactId: contact.contactId,
        contactUrl: contact.contactUrl,
        givenName: contact.givenName,
        lastName: contact.lastName,
        url: contact.url,
        requestType: contact.requestType,
        requestor: contact.requestor,
        expirationDt: contact.expirationDt,
        submitDt: contact.submitDt,
        updatedDt: contact.updatedDt,
        update: false
      }
    })
    setRows(cleanRows);
  }

  const addOptoutContactInitialRow = [{
    givenName: "",
    lastName: "",
    requestType: "",
    requestor: "",
    contactUrl: "",
    expirationDt: "",
  }];

  const [addRowData, SetAddRowData] = useState<RowData[]>([]);
  const [addOptoutContactCount, setAddOptoutContactCount] = useState(0);

  useEffect(()=>{
    optoutcontactsDetails({ optoutContacts: rows });
  },[rows])


  const handleAddRowData = () => {
    SetAddRowData([...addRowData,  ...addOptoutContactInitialRow ]);
    setAddOptoutContactCount(addOptoutContactCount + 1);
  };

  const handleRemoveRowData = () => {
    const copyAddRowData = JSON.parse(JSON.stringify(addRowData));
    copyAddRowData.pop();
    SetAddRowData(copyAddRowData);
  };

  const handleInputChange = (e, rowIndex) => {
    const { name, type, value, checked } = e.target; // Destructure type and checked properties

    // Determine the new value based on input type
    const newValue = type === "checkbox" ? checked : value;

    // Update the specific row and field
    const updatedRows = rows.map((row, index) =>
      index === rowIndex ? { ...row, [name]: newValue } : row
    );

    // Update state with new rows data
    setRows(updatedRows);
  };

  const handleSubmitRowData = async () => {
    const filteredRowData = rows.filter(row => row?.update);
    if(!filteredRowData.length && !addRowData.length){
      toast.error("please select at least one record")
      return;
    }
    // combining update Records and new records
    const finalRowData = [...filteredRowData, ...addRowData];
    const formattedRowData = reFormatRowData(finalRowData);
    try{
      let response;
      setLoading(true);
      for (const item of formattedRowData) {
        response = await updateContactOptout(item);
      }  
      setLoading(false);
      SetAddRowData([]);
      await getContactOptoutRecords();
      toast.info("Records updated");
    } catch(error){
      setLoading(false);
      toast.error("Error while processing the record");
      dnbComLog(LogSeverity.ERROR, "Error while updating the records" + error);
    }
  }

  const reFormatRowData = (filteredRowData) =>{
      return filteredRowData.map(row =>{
      return {
        "expirationDate": [
            row?.expirationDt
        ],
        "givenName": [
            row?.givenName
        ],
        "lastName": [
            row?.lastName
        ],
        "requestors": [
            row?.requestor
        ],
        "requestType": [
            row.requestType
        ],
          "updateExpirationDate": [
            row?.expirationDt
        ],
        "updateGivenName": [
          row?.givenName
        ],
        "updateLastName": [
          row?.lastName
        ],
        "updateRequestor": [
          row?.requestor
        ],
        "updateRequestType": [
          row.requestType
        ],
        "updateUrls": [
           row.contactUrl
        ],
        "urls": [
          row.contactUrl
        ]
      }
    })
  }

  const resetUpdateField =() =>{
    let copyFilteredRowData = JSON.parse(JSON.stringify(rows));
    copyFilteredRowData = copyFilteredRowData.map(item=> {
      if(item.update){
        item.update = false;
        return item
      } return item
    })
    setRows(copyFilteredRowData);

  }

  const requestTypeoOptions = [
    { name: "Temporary", value: "Data update temperary suppression" },
    { name: "Permanent", value: "Contact directory suppression" },
    { name: "Permanent-GCA", value: "Contact directory AND GCA suppression" },
  ];

  const formatSubmitDt=(dateString: any)=>{
    if(isNotUndefinedOrNull(dateString)){
      try {
        const date = (Array.isArray(dateString)) ?
          new Date(dateString[0], dateString[1] - 1, dateString[2])
        :
          new Date(dateString);

        if (isNaN(date.getTime())) {
          throw new Error("Invalid Date");
        }
        return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
      } catch (error) {
        dnbComLog(LogSeverity.ERROR, `Error formatting date: ${dateString}. ${error}`);
      }
    } 
  }

  const formatExpirationDate = (dateValue: string | Array<string | number> | null): string => {
    if (!dateValue) {
      return "";
    }

    const date = Array.isArray(dateValue) ? new Date(dateValue[0], dateValue[1] - 1, dateValue[2]) : new Date(dateValue);

    if (isNaN(date.getTime())) {
      return "";
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  return (
    <>
      <ToastContainer position="top-center" />
      <Loader inProgress={loading} />
      <div className="optoutcontactsWrapper">
        <div className="spinner"></div>

        <div className="addRowWrapper">
          <button className="addRowButton" onClick={handleAddRowData}>
            Add Row
          </button>
          &nbsp; &nbsp;
          <button className="cancelAddRowButton" onClick={handleRemoveRowData}>Cancel Add Row</button>
          &nbsp; &nbsp;
          <button className="submitButton button" onClick={handleSubmitRowData}>Submit</button>
        </div> 

        <div className="mainDivClass">
          {addOptoutContactCount ? (
            <AddOptoutContact
              addRowData= {addRowData}
              addOptoutContactCount={addOptoutContactCount}
              SetAddRowData ={SetAddRowData}
            />
          ) : null}
        </div>

        <div className="errorMessage"></div>

        <hr />

        <div className="exportContactOptoutContainer">
          <div className="exportOptionsToggle">
            <button
              className="exportOptionsButton"
              onClick={() => setEnableExportOptions(!enableExportOptions)}
            >
              Export Options
              <span
                className={classNames({
                  minus: enableExportOptions,
                  plus: !enableExportOptions,
                })}
              ></span>
            </button>
          </div>

          <div
            className={classNames({
              exportOptions: !enableExportOptions,
              exportOptionsVisible: enableExportOptions,
            })}
          >
            <div className="timePeriod">
              <label>Time period:</label>
              <input
                type="date"
                className="timePeriodFromExportFilter"
                name="timePeriodFromExportFilter"

              />
              <span>to</span>
              <input
                type="date"
                className="timePeriodToExportFilter"
                name="timePeriodToExportFilter"
              />
            </div>

            <div className="requestType">
              <label>Request Type:</label>
              <select
                className="requestTypeExportFilter selectclass"
                name="requestTypeExportFilter"
                multiple
              >
                <option value="Temporary">
                  Data update (temporary suppression)
                </option>
                <option value="Permanent">Contact directory suppression</option>
                <option value="Permanent-GCA">
                  Contact directory AND GCA suppression
                </option>
              </select>
              <div className="copy">
                *To select multiple 'Request Type' options please hold CTRL-key
                and click the options
              </div>
            </div>

            <button className="exportButton">Export</button>
          </div>
        </div>

        <hr />
        <h1 className="optoutContactsTitle title">Contact Directory Opt-out</h1>
        <table className="optoutcontactsTableClass blueTable">
          <thead>
            <th>Count</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Contact URL</th>
            <th>Contact ID</th>
            <th>Expiration Date</th>
            <th>Requestor</th>
            <th>Submit Date</th>
            <th>Request Type</th>
            <th>Update</th>
            <thead></thead>
          </thead>
          {rows.map((item, index) => {
            return (
              <tr key={item.contactId}>
                <td>{index+1} </td>
                <td>
                  <input
                    type="textbox"
                    name="givenName"
                    value={item?.givenName}
                    onChange={(e) => handleInputChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="textbox"
                    maxLength={9}
                    name="lastName"
                    value={item.lastName}
                    onChange={(e) => handleInputChange(e, index)}
                  />{" "}
                </td>
                <td>
                  <input
                    type="textbox"
                    name="contactUrl"
                    readOnly={true}
                    value={item.contactUrl}
                  />{" "}
                </td>
                <td>
                  <span>{item.contactId}</span>
                </td>
                <td>
                  <input
                    type="date"
                    id="date-input"
                    name="expirationDt"
                    value={formatExpirationDate(item.expirationDt)}
                    placeholder="dd-mm-yyyy"
                    onChange={(e) => handleInputChange(e, index)}
                  />
                </td>
                <td>
                  <input
                    type="textbox"
                    name="requestor"
                    className="requestor"
                    value={item.requestor}
                    onChange={(e) => handleInputChange(e, index)}
                  />{" "}
                </td>
                <td>{formatSubmitDt(item.submitDt)}</td>
                <td>
                  <select
                    id="example-select"
                    value={item.requestType}
                    onChange={(e) => handleInputChange(e, index)}
                    className="selectclass"
                    name="requestType"
                  >
                    {/* <option value="">-- Select an option --</option> */}
                    {requestTypeoOptions.map((x, i) => (
                      <option key={i} value={x.name}>
                        {x.value}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <input
                    type="checkbox"
                    id="example-checkbox"
                    checked={item.update}
                    name="update"
                    onChange={(e) => handleInputChange(e, index)}
                  />{" "}
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    </>
  );
};

export default OptoutContacts;
